/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCatalogDetailsRequest
 */
export interface UpdateCatalogDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCatalogDetailsRequest
     */
    name: string;
}

/**
 * Check if a given object implements the UpdateCatalogDetailsRequest interface.
 */
export function instanceOfUpdateCatalogDetailsRequest(value: object): value is UpdateCatalogDetailsRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpdateCatalogDetailsRequestFromJSON(json: any): UpdateCatalogDetailsRequest {
    return UpdateCatalogDetailsRequestFromJSONTyped(json, false);
}

export function UpdateCatalogDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCatalogDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UpdateCatalogDetailsRequestToJSON(json: any): UpdateCatalogDetailsRequest {
    return UpdateCatalogDetailsRequestToJSONTyped(json, false);
}

export function UpdateCatalogDetailsRequestToJSONTyped(value?: UpdateCatalogDetailsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

